interface TransferTaxRate {
  buyerTax: number | null;
  specialRules?: {
    thresholds: number[];
    rates: number[];
  };
}

interface City {
  name: string;
  transferTax: TransferTaxRate;
}

interface County {
  name: string;
  cities: City[];
}

export const transferTaxData: County[] = [
  {
    name: "Adams",
    cities: [
      { name: "Quincy", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "Cook",
    cities: [
      { name: "Addison", transferTax: { buyerTax: 2.50 } },
      { name: "Berwyn", transferTax: { buyerTax: 0 } },
      { name: "Buffalo Grove", transferTax: { buyerTax: 0 } },
      { name: "Calumet City", transferTax: { buyerTax: 4 } },
      { name: "Chicago", transferTax: { buyerTax: 7.50 } },
      { name: "Cicero", transferTax: { buyerTax: 0 } },
      { name: "Des Plaines", transferTax: { buyerTax: 0 } },
      { name: "Evanston", transferTax: { 
        buyerTax: 5,
        specialRules: {
          thresholds: [1500000, 5000000],
          rates: [5, 7, 9]
        }
      }},
      { name: "Hoffman Estates", transferTax: { buyerTax: 0 } },
      { name: "Oak Lawn", transferTax: { buyerTax: 0 } },
      { name: "Oak Park", transferTax: { buyerTax: 0 } },
      { name: "Schaumburg", transferTax: { buyerTax: 1 } },
      { name: "Skokie", transferTax: { buyerTax: 0 } },
      { name: "Streamwood", transferTax: { buyerTax: 0 } },
      { name: "Mount Prospect", transferTax: { buyerTax: 3 } },
      { name: "Park Ridge", transferTax: { buyerTax: 0 } },
      { name: "Bedford Park", transferTax: { buyerTax: 0 } },
      { name: "Bellwood", transferTax: { buyerTax: 0 } },
      { name: "Burnham", transferTax: { buyerTax: 5 } },
      { name: "Country Club Hills", transferTax: { buyerTax: 0 } },
      { name: "Dolton", transferTax: { buyerTax: 0 } },
      { name: "Evergreen Park", transferTax: { buyerTax: 0 } },
      { name: "Glenwood", transferTax: { buyerTax: 0 } },
      { name: "Robbins", transferTax: { buyerTax: 0 } },
      { name: "Stickney", transferTax: { buyerTax: 0 } },
      { name: "Stone Park", transferTax: { buyerTax: 0 } },
      { name: "Westchester", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "DuPage",
    cities: [
      { name: "Aurora", transferTax: { buyerTax: 0 } },
      { name: "Bartlett", transferTax: { buyerTax: 0 } },
      { name: "Downers Grove", transferTax: { buyerTax: 0 } },
      { name: "Elmhurst", transferTax: { buyerTax: 0 } },
      { name: "Glendale Heights", transferTax: { buyerTax: 0 } },
      { name: "Naperville", transferTax: { buyerTax: 3 } },
      { name: "Wheaton", transferTax: { buyerTax: 2.50 } },
      { name: "Carol Stream", transferTax: { buyerTax: 0 } },
      { name: "Glen Ellyn", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "Will",
    cities: [
      { name: "Joliet", transferTax: { buyerTax: 0 } },
      { name: "Romeoville", transferTax: { buyerTax: 3.50 } },
      { name: "Plainfield", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "Lake",
    cities: [
      { name: "Waukegan", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "Kane",
    cities: [
      { name: "Elgin", transferTax: { buyerTax: 0 } },
      { name: "Carpentersville", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "Winnebago",
    cities: [
      { name: "Rockford", transferTax: { buyerTax: 7.50 } }
    ]
  },
  {
    name: "McLean",
    cities: [
      { name: "Bloomington", transferTax: { buyerTax: 0 } },
      { name: "Normal", transferTax: { buyerTax: 1 } }
    ]
  },
  {
    name: "Peoria",
    cities: [
      { name: "Peoria", transferTax: { buyerTax: 2.50 } }
    ]
  },
  {
    name: "Champaign",
    cities: [
      { name: "Urbana", transferTax: { buyerTax: 0 } },
      { name: "Champaign", transferTax: { buyerTax: 1 } }
    ]
  },
  {
    name: "St. Clair",
    cities: [
      { name: "Belleville", transferTax: { buyerTax: 3.75 } }
    ]
  },
  {
    name: "Rock Island",
    cities: [
      { name: "Moline", transferTax: { buyerTax: 0 } },
      { name: "Rock Island", transferTax: { buyerTax: 1 } }
    ]
  },
  {
    name: "Tazewell",
    cities: [
      { name: "Pekin", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "Stephenson",
    cities: [
      { name: "Freeport", transferTax: { buyerTax: 0 } }
    ]
  },
  {
    name: "DeKalb",
    cities: [
      { name: "Sycamore", transferTax: { buyerTax: 5 } }
    ]
  }
];

export const calculateTransferTax = (price: number, county: string, city: string): number => {
  const countyData = transferTaxData.find(c => c.name === county);
  if (!countyData) return 0;

  const cityData = countyData.cities.find(c => c.name === city);
  if (!cityData) return 0;

  const { transferTax } = cityData;
  if (!transferTax.buyerTax) return 0;

  if (transferTax.specialRules) {
    // Handle Evanston's special case
    const { thresholds, rates } = transferTax.specialRules;
    if (price <= thresholds[0]) {
      return (price / 1000) * rates[0];
    } else if (price <= thresholds[1]) {
      return (price / 1000) * rates[1];
    } else {
      return (price / 1000) * rates[2];
    }
  }

  return (price / 1000) * transferTax.buyerTax;
};
